export enum SentryContextKeys {
  Referer = 'referer',

  RequestMethod = 'request.method',
  RequestUrl = 'request.url',
  RequestMask = 'request.mask',
  RequestBody = 'request.body',
  RequestHeaders = 'request.headers',
  RequestParams = 'request.params',
  RequestUrlWithParams = 'request.urlWithParams',

  ResponseMessage = 'response.message',
  ResponseError = 'response.error',
  ResponseOk = 'response.ok',
  ResponseHeaders = 'response.headers',
  ResponseStatus = 'response.status',
  ResponseStatusText = 'response.statusText',
  ResponseUrl = 'response.url',

  ResponseErrorMessage = 'response.error.message',
  ResponseErrorReason = 'response.error.reason',
  ResponseErrorSubject = 'response.error.subject',
  ResponseErrorSubjectType = 'response.error.subjectType',
  ResponseErrorType = 'response.error.type',
}
